
import {aiApi} from './ai'

export const completeOAuthApi = aiApi.injectEndpoints({
  endpoints: (builder) => ({
    
    completeOAuth: builder.mutation({
      query: ({ code, state, platform, error, error_description }) => ({
        url: '/social/oauth/complete',
        method: 'POST',
        body: { code, state, platform, error, error_description },
      }),
      invalidatesTags: ['SocialAccount'],
    }),

  }),
  overrideExisting: false,
})

export const { useCompleteOAuthMutation } = completeOAuthApi